import { Button, Grid } from "@material-ui/core";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import { useStore } from "app/stores";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { forwardRef, memo } from "react";
import { Search } from "@material-ui/icons";
import { pagingDepartment } from "app/services/DepartmentService";
import { getCurrentStaff, getPositionCodes, isDoctor, isRoleBranchManager, isRoleExportExcel, isRoleTechician, isSalesConsultant } from "app/common/LocalFunction";
import { pagingStaff } from "app/services/StaffService";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CommonButton from "app/common/Component/Button/CommonButton";
import { pagingPosition } from "app/services/PositionService";
import GlobitsMultiDatePicker from "app/common/form/GlobitsMultiDatePicker";
import { pagingCustomerSource } from "app/services/CustomerSourceService";
import SelectPagingCheckBoxDetail from "app/PatientManagement/ReportPayment/Component/SelectPagingCheckBoxDetail";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import { LAVoucherItemRevenueType } from "app/common/LocalConst";
import { searchByPageStaffGroup } from "app/services/ServiceStaffGroup";

const ReportSalesAllocationSearch = ({ isAdmins, isSalesOrTechicianOrDoctor, isTeamLead, departmentsUser, staffGroupsUser }) => {
  const { searchReportSalesAllocation, handleExportEmployeeReport } =
    useStore().patientManagementStore.reportSalesAllocationStore;

  const handleExport = (values) => {
    handleExportEmployeeReport(values);
  };
  let POSITION_CODES = getPositionCodes();
  const { setFieldValue, values, touched, errors } = useFormikContext();
  const isExportExcel = isRoleExportExcel() || isAdmins // admin luôn thấy nút xuất Excel (tạm để test)
  return (
    <>
      <Grid container spacing={1} className="cards-body">
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsMultiDatePicker
            label="Từ ngày - đến ngày"
            name="fromDate"
            range
            rangeHover
            fromField="fromDate"
            toField="toDate"
          // format={"DD/MM/YYYY"}
          />
          {touched.toDate && errors.toDate && (
            <div style={{ color: "red", fontSize: 12 }}>{errors.toDate}</div>
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <SelectPagingCheckBoxDetail
            name={"listDepId"}
            label={"Cơ sở"}
            api={
              (isAdmins || isSalesOrTechicianOrDoctor || isTeamLead)
                ? pagingDepartment
                : async () => ({
                  data: { content: departmentsUser || [] },
                })
            }
            listSelected={values?.listDepId || []}
            setListOption={(listDepId) => {
              setFieldValue("listDepId", listDepId);
            }}
          // required
          />
        </Grid>
        {/* <Grid item xs={12} sm={6} md={2}>
          <SelectPagingCheckBoxDetail
            name={"staffIds"}
            label={"Nhân viên"}
            api={pagingStaff}
            listSelected={values?.staffIds || []}
            setListOption={(staffIds) => {
              setFieldValue("staffIds", staffIds);
            }}
            getOptionLabelCustom={(option) => option?.staffName || ""}
            hideSelectAll={true}
            //disabled={isRoleCt}
            searchObject={{ isActive: true }}
            ListboxComponent={forwardRef((props, ref) => {
              const { children, ...other } = props;
              return (
                <ul {...other} ref={ref}>
                  <ol>
                    <li>{children}</li>
                  </ol>
                </ul>
              );
            })}
            renderOption={(option) => renderOptionsStaff(option)}
          />
        </Grid> */}
        {(isAdmins || isTeamLead) && (
          < Grid item xs={12} sm={6} md={2}>
            <SelectPagingCheckBoxDetail
              name={"listStaffGroupId"}
              label={"Nhóm nhân viên"}
              api={
                isAdmins
                  ? searchByPageStaffGroup
                  : async () => ({
                    data: { content: staffGroupsUser || [] },
                  })
              }
              listSelected={values?.listStaffGroupId || []}
              setListOption={(listStaffGroupId) => {
                setFieldValue("listStaffGroupId", listStaffGroupId);
              }}
            />
          </Grid>
        )}

        <Grid item xs={12} sm={6} md={2}>
          <GlobitsPagingAutocomplete
            api={pagingStaff}
            label="Nhân viên"
            name="staffIds"
            searchObject={{
              // departmentId: values?.departmentId?.id,
              // positionCode: POSITION_TELESALE,
              listStaffGroupId: Array.isArray(values?.listStaffGroupId) ? values?.listStaffGroupId.map((x) => x.id) : [],
              isActive: true,
            }}
            getOptionLabel={(option) => option?.staffName || ""}
            multiple
            ListboxComponent={forwardRef((props, ref) => {
              const { children, ...other } = props;
              return (
                <ul {...other} ref={ref}>
                  <ol>
                    <li>{children}</li>
                  </ol>
                </ul>
              );
            })}
            renderOption={(option) => renderOptionsStaff(option)}
            disabled={!isTeamLead && isSalesOrTechicianOrDoctor}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <GlobitsPagingAutocomplete
            name={"positionIds"}
            label={"Vai trò"}
            api={pagingPosition}
            searchObject={{
              isUsing: true,
              positionCodes: POSITION_CODES,
            }}
            multiple
          // disabled={!isAdmins}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsTextField
            label="Tên khách hàng"
            placeholder="Tên khách hàng"
            name="patientName"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsPagingAutocomplete
            api={pagingCustomerSource}
            label="Nguồn"
            name="sourceIds"
            multiple
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsTextField
            label="Mã khách hàng"
            placeholder="Mã khách hàng"
            name="patientCode"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsTextField
            label="Số điện thoại"
            placeholder="SĐT"
            name="phoneNumber"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsSelectInput
            label={"Loại doanh thu"}
            name={`voucherItemRevenueType`}
            options={LAVoucherItemRevenueType.getListData()}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <GlobitsTextField
            label="Tìm kiếm"
            placeholder="Nhập mã"
            name="keyword"
          />
        </Grid>
        <Grid item xs={12} sm={6} md="auto" className="flex flex-end gap-2">
          {isExportExcel && (
            <CommonButton
              className="btn-add"
              onClick={() => handleExport(values)}
            >
              <CloudDownloadIcon />
              Xuất excel báo cáo
            </CommonButton>
          )}
          <Button className="btn-primary" type="submit">
            <Search />
            Tìm kiếm
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export const renderOptionsStaff = (option) => {
  const staffName = option?.staffName || "Không có tên";
  const staffCode = option?.code;

  const shortNames = option?.staffDepartments
    ?.map((sd) => sd?.department?.shortName)
    .filter(Boolean);

  const shortNameDisplay = shortNames?.length
    ? `(${shortNames.join(", ")})`
    : "";

  const parts = [staffName];
  if (staffCode) parts.push(staffCode);
  if (shortNameDisplay) parts.push(shortNameDisplay);

  return (
    <div style={{ fontSize: "14px", color: "#000", padding: "4px 0" }}>
      {parts.join(" - ")}
    </div>
  );
};

export default memo(observer(ReportSalesAllocationSearch));
